import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { MatDialog, MatSnackBar } from '@angular/material';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { LearnerService } from '../../services/learner.service';
import { UserRoleService } from '../../services/user-role.service';
@Component({
  selector: 'app-specimen-signature',
  templateUrl: './specimen-signature.component.html',
  styleUrls: ['./specimen-signature.component.scss']
})
export class SpecimenSignatureComponent implements OnInit {

  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentData
  specimanForm: any;
  learnerData
  jobData
  instructorsList = []
  selectedTrainer = []
  learnerName
  specimanEdit
  loading = false
  isEdit: boolean = false
  trainerSign4
  currentUser: any;
  user: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  constructor(
    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    public _learnerService: LearnerService,
    public _snackBar: MatSnackBar,
    public _userRoleService : UserRoleService
  ) { }

  ngOnInit() {
    if (!this.isEdit)
      this.createForm()
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes of job and learner data", changes);
    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue[0]
      this.getUserRole();
      this.instructorsList = this.jobData.instructors
      console.log("instructorsList ====== instructorsList", this.jobData);

    }

    if (changes.singleLearner && changes.singleLearner.currentValue && changes.singleLearner.currentValue != undefined) {
      this.learnerData = changes.singleLearner.currentValue
      this.learnerName = this.learnerData.name
    }

    if (changes.assessmentData && changes.assessmentData.currentValue) {
      this.specimanEdit = changes.assessmentData.currentValue
      console.log("edit form value", this.specimanEdit);
      let size = Object.keys(this.specimanEdit).length;
      console.log("what is the size of object", size);

      if (size != 0) {
        // this.selectedTrainer = this.specimanEdit.specimanForm.trainer
        this.isEdit = true
        this.createForm(this.specimanEdit)
      }
    }

  }
  getUserRole(){
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors,'job');
    
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true

    
  }



  // FORM GROUP

  createForm(details?) {


    this.specimanForm = new FormGroup({
      leanerName: new FormControl((details && details.specimanForm) ? details.specimanForm.leanerName : this.learnerName),
      trainer: new FormControl((details && details.specimanForm) ? details.specimanForm.trainer : []),
      date: new FormControl((details && details.specimanForm) ? details.specimanForm.date : ''),
      location: new FormControl((details && details.specimanForm) ? details.specimanForm.location : ''),
      specimanDetails: this.formBuilder.array(this.specimanData((details && details.specimanForm) ? details.specimanForm.specimanDetails : []))
    })

  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'specimanForm')
      this.specimanForm.get(formControl).setValue(value);
  }


  get actionsDetails() { return <FormArray>this.specimanForm.get('specimanDetails'); }

  specimanData(details?) {

    if (details && details.length) {
      let unitArray = []
      _.forEach(details, async (item, index) => {
        await unitArray.push(new FormGroup({
          name: new FormControl((item && item.name) ? item.name : ''),
          destination: new FormControl((item && item.destination) ? item.destination : ''),
          specimanSign: new FormControl((item && item.specimanSign) ? item.specimanSign : ''),
          specimanInitials: new FormControl((item && item.specimanInitials) ? item.specimanInitials : ''),
          contactNumber: new FormControl((item && item.contactNumber) ? item.contactNumber : ''),
        }))
      })
      return unitArray;
    } else {
      return [this.formBuilder.group({
        name: new FormControl(''),
        destination: new FormControl(''),
        specimanSign: new FormControl(''),
        specimanInitials: new FormControl(''),
        contactNumber: new FormControl(''),
      })]
    }
  }



  addSpeciman() {
    const control = <FormArray>this.specimanForm.controls.specimanDetails

    control.push(this.formBuilder.group({
      name: new FormControl(''),
      destination: new FormControl(''),
      specimanSign: new FormControl(''),
      specimanInitials: new FormControl(''),
      contactNumber: new FormControl(''),
    }))
  }


  deleteSpeciman(data, i) {
    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.specimanForm.controls.specimanDetails
    control.removeAt(i)
  }



  // UTILITY




  compareObjects(o1: any, o2: any): boolean {
    console.log("compareObjects called", o1, o2)
    if (o1 && o2) {
      return o1 === o2;
    }

  }

  addSignature(item, i) {
    console.log("value of item", item);
    console.log("value of index", i);
    if (this.isLearner || this.isIQA) {
    }
    else {
      this.openDialog(SignaturePadComponent).subscribe((data) => {
        if (data == undefined) return

        let sign = data
        const control = <FormArray>this.specimanForm.controls.specimanDetails
        console.log("what is control ", control.controls[i]);
        control.at(i).patchValue({
          specimanSign: sign
        });
        // console.log("final form value", this.specimanForm.value);
      })
    }
  }




  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }



  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  // API CALL



  submitSpeciman() {
    console.log("final form value print", this.specimanForm.value);
    this.loading = true
    let data = {
      learnerId: this.learnerData._id,
      jobId: this.jobData._id,
      version: true,
      details: {
        specimanForm: this.specimanForm.value
      }
    }
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })


  }



}



